import React from 'react';
import Customers from './Customers';

import { shallowEqual, useSelector } from 'react-redux';

export default function CustomerPage() {
  const { authorizedUser } = useSelector(
    ({ auth }) => ({
      authorizedUser: auth.user,
    }),
    shallowEqual
  );
  return (
    <div>
      <Customers authorizedUser={authorizedUser} />
    </div>
  );
}
